import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div style={{ padding: '2rem', margin: 'auto' }}>
      <h1>Privacy Policy for Tran Logistics</h1>
      <p>
        <strong>Effective Date:</strong> June 3, 2025
      </p>

      <h4 style={{ marginTop: 10 }}>1. Information We Collect</h4>
      <p>
        <strong>a. Personal Information:</strong> Name, phone number, email, company name, role (Consignor, Consignee,
        Transporter)
      </p>
      <p>
        <strong>b. Shipment and Operational Data:</strong> Pickup/delivery addresses, tracking info, uploaded documents
      </p>
      <p>
        <strong>c. Location Data:</strong> Real-time location (used for transporter routing)
      </p>
      <p>
        <strong>d. Device & Usage Data:</strong> Device type, IP, crash logs
      </p>

      <h4 style={{ marginTop: 10 }}>2. How We Use Your Information</h4>
      <p>To manage shipments, enable communication, and improve app functionality.</p>

      <h4 style={{ marginTop: 10 }}>3. Sharing Your Information</h4>
      <p>
        We don’t sell your data. We share it only with authorized logistics partners, legal authorities, and service
        providers.
      </p>

      <h4 style={{ marginTop: 10 }}>4. Data Security</h4>
      <p>We use encryption and other security measures to protect your data.</p>

      <h4 style={{ marginTop: 10 }}>5. Your Rights</h4>
      <p>Access or delete your data, or turn off location access via settings.</p>

      <h4 style={{ marginTop: 10 }}>6. Third-Party Services</h4>
      <p>Maps, analytics, and other tools may be powered by third parties with their own policies.</p>

      <h4 style={{ marginTop: 10 }}>7. Children’s Privacy</h4>
      <p>Not intended for users under 18 years of age.</p>

      <h4 style={{ marginTop: 10 }}>8. Changes to This Policy</h4>
      <p>We may update this policy periodically and notify users in the app.</p>

      <h4 style={{ marginTop: 10 }}>9. Contact Us</h4>
      <p>
        Email: support@tranlogistics.com <br />
        Phone: +918269656605 <br />
        Address: Bharat Vihar, SN 6, Gulawani Maharaj Road, opposite DTDC Courier, Swapnamandir Society, Vakil Nagar,
        Erandwane, Pune, Maharashtra 411004
      </p>
    </div>
  );
}
